import { useEffect, useState } from "react";

const APP_VERSION = process.env.REACT_APP_BUILD_VERSION;

export function useCheckAppVersion() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === "development") return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch("/meta.json", { cache: "no-store" });
        const json = await res.json();

        if (json.version !== APP_VERSION) {
          setUpdateAvailable(true);
        }
      } catch (e) {
        console.warn("Version check failed", e);
      }
    }, 600000); // check every 10min

    return () => clearInterval(interval);
  }, []);

  return updateAvailable;
}
